import React from 'react';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import Head from 'next/head';
import { useForm } from '@mantine/form';
import Subscription from "@/components/section/subscription";
import { pagelink } from "../../config/site";
import _ from "lodash";
import { Button, LoadingOverlay, TextInput, UnstyledButton} from '@mantine/core';
import { useState } from 'react';
import { toast } from "@/libraries/swal";
import { _postURL } from '../api';
import { useScrollLock } from '@mantine/hooks';

export default function Index(props) {
    const { t } = props;

    const [isProcessing, setIsProcessing] = useState(false);
    const [scrollLocked, setScrollLocked] = useScrollLock(false);

    const { getInputProps, onSubmit, isValid } = useForm({
        validateInputOnChange: true,
        initialValues: {
            email: ''
        },
        validate: {
            email: (inputValue) => !(/^\S+@\S+$/.test(inputValue)) && 'Invalid email',
        }
    });

    const sendResetEmail = async (formData) => {
        setIsProcessing(true);
        // setScrollLocked(true);
        
        try {
            const response = await _postURL("/api/auth/forget-password", { ...formData });

            if (!_.isObjectLike(response) || _.isEmpty(response.data)) throw "Can't find any account associate with the email!";

            await toast.success('Sent!', true, {
                // didDestroy: () => { location.pathname = pagelink.authentication.verification }
            });

        } catch (error) {
            toast.error(error)

        } finally {
            setIsProcessing(false);
            // setScrollLocked(false);
        }
    }

    return (
        <>
            <Head>
                <title>{t('Forgot_password')} | {t('Site_name')}</title>
            </Head>

            <div className="page-content">
                <section className="register-success-sec pt-3">
                    <div className="col-9 mx-auto custom_container2">
                        <div className="row">
                            <div className="col-12">
                                <h1 className="login-form-layout-title">
                                    {t('Forgot_password')}
                                </h1>
                                <div className="login-form-layout-message-otp">{t('Get_a_password_reset')}</div>
                                <div className="login-form-layout-message-title-otp">
                                    {t('Password_reset_text')}
                                </div>
                                <div className="call-action-left">
                                    <LoadingOverlay visible={isProcessing} overlayBlur={1} />
                                    <form onSubmit={onSubmit((values) => sendResetEmail(values))} className="d-flex flex-column">
                                        <TextInput 
                                            type='email'
                                            name='email'
                                            placeholder='Enter email address'
                                            classNames={{
                                                input: `form-control`,
                                                error: `text-end`
                                            }}
                                            styles={{
                                                root: { width: '100%' }
                                            }}
                                            { ...getInputProps('email') }
                                        />
                                        {/*<Button
                                            classNames={{
                                                root: 'btn shadow-none login-btn-pill-bg'
                                            }}
                                            type='submit'
                                            component='button'
                                            disabled={!isValid()}
                                            sx={{
                                                ":disabled": {
                                                    opacity: .7,
                                                    backgroundColor: '#bb9b6a',
                                                    color: '#fff'
                                                },
                                                ":hover": {
                                                    backgroundColor: '#bb9b6a',
                                                }
                                            }}
                                        >{t('Send')}</Button>*/}
                                        <button type="submit" className="btn shadow-none login-btn-pill btn-filled gradient-hover-effect border-0" disabled={!isValid()}>
                                            {t('Send')
                                        }</button>
                                    </form>
                                </div>
                                <div className="d-flex justify-content-center flex-column align-items-center">
                                    <ul className="m-0 p-0 d-flex align-items-center terms-style">
                                        <li><a href={pagelink.general.termsAndCondition}>{t('Terms_of_use')}</a></li>
                                        <li className="divider"> | </li>
                                        <li><a href={pagelink.general.privacyPolicy}>{t('Privacy_policy')}</a></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>

            {/** Subscription Part */}
            <Subscription {...props}/>
        </>
    )
}

export async function getStaticProps(data) {
    return {
        props: {
            ...(await serverSideTranslations(data.locale, ['common'])),
        },
    };
}